import React from "react"
// MUI
import {Button, Grid, Typography} from "@mui/material"
import SendIcon from "@mui/icons-material/Send"
// style
import {style} from "./style"

export default function QRCodeSMS(props: any) {

    const {fieldDisplay} = props

    const to: string = encodeURIComponent(fieldDisplay.phone as string);
    const bodySms: string = encodeURIComponent(fieldDisplay.message as string);
    const _hrefSms: string = `sms:${to}?body=${bodySms}`;

    return (
        <Grid item xs={12} sx={style.mainWrapper}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4} sx={style.phonePH}>
                    <Typography variant={"body1"} sx={style.fieldText}>
                        <strong>To:</strong>
                        <br/>
                        {fieldDisplay.phone}
                    </Typography>
                    <br/>
                    <Typography variant={"body1"} sx={style.fieldText}>
                        <strong>Message:</strong>
                        <br/>
                        {fieldDisplay.message}
                    </Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant={'contained'}
                        sx={style.button}
                        href={_hrefSms}
                        target={'_blank'}
                    >
                        <SendIcon style={style.sendIcon}/> Send
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
